import { canv } from "@/canv/global";
import { Shape } from "../shape";

export class ShapeHistoryPseudoState extends Shape {
    width = 200;
    height = 200;
    defaultBorderWidth = 4;
    needFill = false;
    defaultColor = "transparent";
    includeText = false;

    setDrawStyle(_: any): void {}

    draw(
        x: number,
        y: number,
        w: number,
        h: number,
        shapeStyles: {
            color: string;
            borderColor: string;
            borderDashType: string;
            borderWidth: number;
        },
    ) {
        canv.ctx.save();
        canv.ctx.fillStyle = shapeStyles.color;
        canv.ctx.strokeStyle = shapeStyles.borderColor;
        canv.ctx.lineWidth = shapeStyles.borderWidth;
        canv.ctx.lineCap = "round";

        canv.ctx.beginPath();
        canv.ctx.ellipse(x + w / 2, y + h / 2, h / 2, w / 2, Math.PI / 2, 0, 2 * Math.PI);

        canv.ctx.moveTo(x + w / 2 - (w * 3) / 22, y + h / 2 - (h * 5) / 22);
        canv.ctx.lineTo(x + w / 2 - (w * 3) / 22, y + h / 2 + (h * 5) / 22);

        canv.ctx.moveTo(x + w / 2 + (w * 3) / 22, y + h / 2 - (h * 5) / 22);
        canv.ctx.lineTo(x + w / 2 + (w * 3) / 22, y + h / 2 + (h * 5) / 22);

        canv.ctx.moveTo(x + w / 2 - (w * 3) / 22, y + h / 2);
        canv.ctx.lineTo(x + w / 2 + (w * 3) / 22, y + h / 2);
        canv.ctx.fill();
        canv.ctx.stroke();
        canv.ctx.closePath();
        canv.ctx.restore();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="m8.82126 7.35178v4.79942m0 0v4.6878m0-4.6878h6.02244m0 0v-4.79942m0 4.79942v4.6878m8.1563-4.839c0 6.0751-4.9249 11-11 11-6.07513 0-11-4.9249-11-11 0-6.07513 4.92487-11 11-11 6.0751 0 11 4.92487 11 11z"
                fill="${fill}" stroke="${stroke}" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;
    }
}
